export default __webpack_public_path__ + "static/media/plug.98cd3e83.svg";